let lastScrollTop = 0;
const header = document.getElementById('header');
const hero = document.getElementById('hero');
const heroHeight = hero.offsetHeight;

window.addEventListener('scroll', () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Überprüfung, ob nach oben oder unten gescrollt wird
  if (scrollTop > lastScrollTop) {
    // Scrolling nach unten
    header.classList.add('nav-hidden');
    header.classList.remove('nav-visible');
  } else {
    // Scrolling nach oben
    header.classList.remove('nav-hidden');
    header.classList.add('nav-visible');

    // Die Klasse "scrolled" sollte nur entfernt werden, wenn man ganz oben ist
    if (scrollTop <= 0) { 
      header.classList.remove('scrolled'); 
    } else {
      header.classList.add('scrolled');
    }
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}, false);
